import * as React from 'react';
import { Avatar, AvatarFallback, AvatarImage, ProfileAvatar, UserIcon } from '@repo/ui-web';
import { avatarStates } from '../../catalog/component-states';
import { StateToggle } from '../../components/StateToggle';

export function AvatarShowcase() {
  const [state, setState] = React.useState<(typeof avatarStates)[number]>('image');

  return (
    <div className="space-y-8">
      <div className="space-y-4">
        <StateToggle options={avatarStates} value={state} onChange={setState} label="State" />
        <div className="flex items-center gap-4">
          <Avatar className="h-12 w-12">
            {state === 'image' ? <AvatarImage src="/brand/logo-400.png" alt="Brand" /> : null}
            {state === 'initials' ? <AvatarFallback>PS</AvatarFallback> : null}
            {state === 'fallback' ? (
              <AvatarFallback>
                <UserIcon className="size-icon-lg" />
              </AvatarFallback>
            ) : null}
          </Avatar>
          <div>
            <p className="text-sm font-semibold text-foreground">Patricia Snow</p>
            <p className="text-xs text-muted-foreground">patricia@company.com</p>
          </div>
        </div>
      </div>

      <div className="space-y-2">
        <p className="text-xs font-semibold uppercase tracking-[0.2em] text-muted-foreground">
          ProfileAvatar
        </p>
        <div className="flex items-center gap-4">
          <ProfileAvatar name="Patricia Snow" imageUrl="/brand/logo-400.png" alt="With image" />
          <ProfileAvatar name="Patricia Snow" alt="With name" />
          <ProfileAvatar email="patricia@company.com" alt="With email" />
          <ProfileAvatar alt="Empty" />
        </div>
      </div>
    </div>
  );
}
